skrilla.controller('deactivateCardModalCtrl', function ($scope, searchService, modalService, cacheService) {
    $scope.card = cacheService.getObjectOrElse("creditCard", function () {
        modalService.dismissAll()
    });

    const disabled = $scope.card.disabled
    $scope.action = disabled ? "Re-enable" : "Disable"
    $scope.path = "creditCards/" + $scope.card.cardId + "/" + (disabled ? "enable" : "disable");
    $scope.deactivate = function () {
        searchService.put($scope.path, {reason: $scope.reason }, `Card successfully ${$scope.action}d`).then(function (response) {
            $scope.card = response.data
            modalService.dismissAll();
        });
    }

});